__webpack_require__.p = "https://assets.worldcubeassociation.org/nextjs/499386d3d0976012eb3b7d80962935281773539f/_next/";